import React from 'react';
import { studyCalculators_En } from '../ConstantsEN';
import SharedHelmet from '../Helmet';
const TITLE = 'Study Calculators - Free Calculators for GPA and Grade Conversion';
const DESCRIPTION = 'Explore our collection of free study calculators, including GPA calculators and grade conversion between different grading systems.';
const KEYWORDS = 'Study calculators, free calculators, GPA calculator, grade conversion calculator, GPA, grading system';
const OG_URL = 'https://do-calculate.com/en/study-calculators';
function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th className="gpa-header">Calculator</th>
                        <th className="gpa-header">Description</th>
                    </tr>
                </thead>
                <tbody>
                    {studyCalculators_En.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
